

export class Breadcrumb {
  static empty(): Breadcrumb {
      return new Breadcrumb(`~`, []);
  }
  constructor(public name: string, public children: string[] = [], public ignorePath: string[] = []) {
  }
}
